import util from 'util';
import { CONSTANT } from '@const';
import { AcceptTermsPayload, TermsAndConditionsType } from '@types';
import { getCurrentDateTime } from '@utils';

import { ApiParams, ApiService } from '../api/ApiService';

export class TermsAndConditionsService extends ApiService {
	static async getTermsAndConds(): Promise<TermsAndConditionsType> {
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.TERMS_AND_CONDITIONS_API_URL,
		};
		return await this.executeApiRequest(params);
	}

	static async acceptTermsAndConds(termsAndConditionsId: string) {
		const payload: AcceptTermsPayload = {
			action: 'ACCEPT',
			auditDate: getCurrentDateTime(),
		};
		const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.ACCEPT_TERMS_AND_CONDITIONS_API_URL, termsAndConditionsId),
			data: payload,
		};
		return await this.executeApiRequest(params);
	}
}
